import { Box, Modal } from "@mui/material";
import React, { useMemo, useState } from "react";
import { ModalStyle } from "../../../../common/components/ModalStyle";

import SearchBar from "../../../../common/components/FormFields/SearchBar";
import DatePickerField from "../../../../common/components/FormFields/DatePickerFieldNew";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import { useForm } from "react-hook-form";
import CommonTransactionPaginationTable from "../../../../common/components/CommonTable/CommonDynamicTablePaginationNew";
import {
  fetchTransferCssdItemsList,
  fetchTransferCssdItemsListPrievous,
  getpeviousRequestListdropdown,
} from "../../../services/transferReceiveCssdServices/TransferReceiveCssdServices";
import { format } from "date-fns";
import { CloseModalIcon } from "../../../../common/components/assets/commonassets/CommonAssets";

const TransferReceiveCSSDModal = ({ openPreviousListModal, setOpenPreviousListModal, selectedScreen }) => {
  const [previousTransferItemList, setPreviousTransferItemList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);
  const [count, setCount] = useState(0);

  const [searchString, setSearchString] = useState("");
  const [kitSearchString, setKitSearchString] = useState("");
  const [itemDropdownOptions, setItemDropdownOptions] = useState([]);
  const [kitDropdownOptions, setKitDropdownOptions] = useState([]);
  const [selectedKit, setSelectedKit] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [itemInputValue, setItemInputValue] = useState("");
  const [kitInputValue, setKitInputValue] = useState("");

  const [listingObject, setListingObject] = useState({
    searchString: "",
    searchId: null,
    fromDate: null,
    toDate: null,
    page: 0,
    size: rowsPerPage,
  });

  const { control, watch } = useForm({ defaultValues: { fromDate: null, toDate: null } });
  const getFromDate = watch("fromDate");
  const getToDate = watch("toDate");

  // Fetch table data
  const populateTable = async (forPagination = false) => {
    try {
      // const payload = {
      //   searchString: searchString || "",
      //   fromDate: listingObject?.fromDate ? format(new Date(listingObject.fromDate), "yyyy-MM-dd") : null,
      //   toDate: listingObject?.toDate ? format(new Date(listingObject.toDate), "yyyy-MM-dd") : null,
      //   page: !forPagination ? 0 : page,
      //   size: rowsPerPage,
      // };

      const payload = {
        page: !forPagination ? 0 : page,
        size: rowsPerPage,

        itemid: selectedItem?.value || null,
        kitid: selectedKit?.value || null,

        searchitemString: searchString || "",
        searchkitString: kitSearchString || "",

        fromDate: listingObject?.fromDate
          ? format(new Date(listingObject.fromDate), "yyyy-MM-dd")
          : null,

        toDate: listingObject?.toDate
          ? format(new Date(listingObject.toDate), "yyyy-MM-dd")
          : null,
      };

      const response = await fetchTransferCssdItemsListPrievous(payload);

      if (!forPagination) {
        setPreviousTransferItemList(response?.data?.result || []);
        setPage(0);
      } else {
        setPreviousTransferItemList(prev => [...prev, ...(response?.data?.result || [])]);
      }
      setCount(response?.data?.count || 0);
    } catch (err) {
      console.error("Error fetching previous CSSD requests:", err);
      setPreviousTransferItemList([]);
      setCount(0);
    }
  };

  const handleItemInputChange = async (inputValue) => {
    setItemInputValue(inputValue);
    setSearchString(inputValue);

    if (!inputValue) {
      setItemDropdownOptions([]);
      return;
    }

    try {
      const response = await getpeviousRequestListdropdown("item", inputValue);
      setItemDropdownOptions(response?.data?.result || []);
    } catch (err) {
      console.error(err);
      setItemDropdownOptions([]);
    }
  };


  const handleKitInputChange = async (inputValue) => {
    setKitInputValue(inputValue);
    setKitSearchString(inputValue);

    if (!inputValue) {
      setKitDropdownOptions([]);
      return;
    }

    try {
      const response = await getpeviousRequestListdropdown("kit", inputValue);
      setKitDropdownOptions(response?.data?.result || []);
    } catch (err) {
      console.error(err);
      setKitDropdownOptions([]);
    }
  };



  useMemo(() => {
    populateTable();
  }, [listingObject?.fromDate, listingObject?.toDate]);

  return (
    <Modal open={openPreviousListModal}>
      <Box sx={ModalStyle} className="w-[85%] h-[85%] space-y-2">
        <div className="flex justify-between">
          <label className="font-semibold">
            {selectedScreen === "Transfer"
              ? "Previous Transfer List"
              : selectedScreen === "Receive"
                ? "Previous Receive List"
                : "Previous Request List"}
          </label>
          <button onClick={() => setOpenPreviousListModal(false)}>
            <CloseModalIcon />
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
          <SearchBar
            placeholder="Search By Item Name"
            searchIcon
            isClearable

            dataArray={itemDropdownOptions}
            handleInputChange={handleItemInputChange}

            onChange={(option) => {
              setSelectedItem(option);
              setSearchString(option?.label || "");
              setItemInputValue(option?.label || "");
            }}
          />

          <SearchBar
            placeholder="Search By Kit Name"
            searchIcon
            isClearable

            dataArray={kitDropdownOptions}
            handleInputChange={handleKitInputChange}

            onChange={(option) => {
              setSelectedKit(option);
              setKitSearchString(option?.label || "");
              setKitInputValue(option?.label || "");
            }}
          />

          <div className="grid grid-cols-2 gap-2">
            <DatePickerField control={control} name="fromDate" label="From Date" inputFormat="dd-MM-yyyy" />
            <DatePickerField control={control} name="toDate" label="To Date" inputFormat="dd-MM-yyyy" />
          </div>

          <div className="flex items-center gap-2">
            <CommonButton
              type="button"
              searchIcon
              className="bg-customBlue text-white"
              onClick={() => {
                const updatedObject = {
                  ...listingObject,
                  page: 0,
                  fromDate: getFromDate ? getFromDate : null,
                  toDate: getToDate ? getToDate : null,
                };

                setListingObject(updatedObject);

                populateTable(false);
              }}
            />

            <CommonButton
              type="button"
              label="Reset"
              className="border border-customRed text-customRed"
              onClick={() => {
                setSearchString("");
                setKitSearchString("");
                setListingObject({
                  searchString: "",
                  searchId: null,
                  fromDate: null,
                  toDate: null,
                  page: 0,
                  size: rowsPerPage,
                });
                setPreviousTransferItemList([]);
                setCount(0);
              }}
            />
          </div>
        </div>

        <div>
          {previousTransferItemList?.length > 0 ? (
            <CommonTransactionPaginationTable
              dataResult={previousTransferItemList}
              page={page}
              setPage={setPage}
              count={count}
              rowsPerPage={rowsPerPage}
              tableHeading={"Previous Item List"}
              removeHeaders={[
                "Transfer Date",
                "Receive Date",
                "Transferred By",
                "Received By",
                "Ot Details Id",
                // "Item Id",
                "itemId",
                "Created Date",
                "Last Modified Date",
                "Cleaned Qty",
                "Cleaning Status",
                "Decontamination Status",
                "Sterilization Qty",
                "Sterilization Status",
                "Wrapped Qty",
                "Wrapping Status",
                "Cleaned By",
                "Wrapped By",
                "Sterilized By",
                "Receive Status",
                "Sterilization Status Type",
                "Transfer Status",
                "Sterilization End By",
                "Sterilization Start By",
                "Transferred By",
                "Id",
                "Created Date",
                "Created By",
                "Last Modified By",
                "Status",
                "Sent By",
                "Used Quantity",
                "Item Kit Id",
                "Sterilization Equipment",
                "Sterilization Equipment Id",
                "Sterilization Method",
                "Sterilization Method Id",
                "Sterilization ExpiryDate",
                "AddToStock Qty",
                "Wrapper Type Id",
                "Wrapper Type",
                "Wrapping Method Id",
                "Wrapping Method",
                "Sterilization End Date",
                "Sterilization Start Date",
                selectedScreen === "Transfer" && "Receive Qty",
                selectedScreen === "Receive" && "Transfer Qty",
              ]}
            />
          ) : (
            <div className="w-full h-96 flex justify-center items-center font-semibold border border-gray-300 rounded">
              No Records Found...
            </div>
          )}
        </div>
      </Box>
    </Modal>
  );
};

export default TransferReceiveCSSDModal;